import { connect } from "react-redux";
import { IncidentReportForm as Component, IncidentReportFormProps } from "./IncidentReportForm.component";
import { loadIncidentReportPage, saveFormToState } from "../../action";
import { getCustomerType, getIncidentReportQuestions, getPrefilledData } from "../../selector";
import { RootState } from "../../reducers";

const mapStateToProps = (state: RootState) =>
  ({
    customerType: getCustomerType(state),
    prefilledData: getPrefilledData(state),
    questions: getIncidentReportQuestions(state),
  } as Pick<IncidentReportFormProps, "customerType" | "prefilledData" | "questions">);

export const IncidentReportForm = connect(mapStateToProps, {
  onCompleteForm: saveFormToState,
  onInit: loadIncidentReportPage,
} as Pick<IncidentReportFormProps, "onCompleteForm" | "onInit">)(Component);
